import { getConfiguration } from "./configuration";
import { getLocaleTimestamp } from "./getLocaleTimestamp";

export function groupEventsByDate(events) {
    const conf = getConfiguration();
    const dates = [];
    const eventsByDate = {};
    events.forEach(match => {
        let timestamp = conf.dbutc ? getLocaleTimestamp(match.timestampDB): match.timestampDB;
        timestamp = timestamp.split(' ')[0];  // Prendi solo la data
        if (eventsByDate[timestamp] == null) {
            eventsByDate[timestamp] = [];
            dates.push(timestamp);
        }
        eventsByDate[timestamp].push(match);
    });
    dates.sort();

    return [dates, eventsByDate];
}
